<template>
  <footer class="container">
    <div class="content">
      <span>
        <prismic-image class="footer-icon" :field="prismic_data.footer_main_image" />
        <div>
          <p
            v-for="(footerText, index) in prismic_data.footer_text"
            v-bind:key="index"
          >{{footerText.text}}</p>
          <div class="legal">
            <a @click="openPrivacyPolicy()" href="#privacy-policy">Privacy policy</a>
          </div>
        </div>
      </span>
      <div class="logos">
        <prismic-image
          v-for="(footerImage, index) in prismic_data.footer_images"
          v-bind:key="index"
          :field="footerImage.footer_image"
        />
      </div>
    </div>
    <div v-show="showPrivacy" id="privacy-policy">
      <div class="container modal-content">
        <a @click="closePrivacyPolicy($event)" class="close" href>
          <font-awesome-icon icon="times" />
        </a>
        <h6>{{prismic_data.privacy_policy_title}}</h6>
        <prismic-rich-text :field="prismic_data.privacy_policy_content" />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
  props: {
    prismic_data: {
      type: Object,
      required: true,
    },
    openedPolicy:{
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showPrivacy: this.openedPolicy,
    };
  },
  methods: {
    openPrivacyPolicy() {
      this.showPrivacy = true;
    },
    closePrivacyPolicy(e) {
      e.preventDefault();
      this.$router.push("/");
      this.showPrivacy = false;
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  margin-bottom: 180px;
  margin-top: 100px;
  @media (max-width: $breakpoint-sm) {
    padding: 0 30px;
    margin-bottom: 25px;
  }
  .footer-icon {
    padding-right: 50px;
    @media (max-width: $breakpoint-sm) {
      float: left;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-self: center;
  }
  .logos {
    margin-top: 15px;
    img {
      margin-right: 10px;
    }
  }
  span {
    display: block;
    display: flex;
    align-items: center;
    @media (max-width: $breakpoint-sm) {
      display: block;
    }
    p {
      color: $color-black;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .legal {
    a {
      font-size: 12px;
      color: $color-black;
      text-decoration: underline;
    }
  }

  #privacy-policy {
    position: fixed;
    z-index: 1;
    padding-top: 50px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    .modal-content {
      position: relative;
      @include round-border(6px);
      background-color: #fff;
      margin: auto;
      padding: 16px;
      -moz-box-shadow: 0 0 5px 1px #5f5f5f;
      -webkit-box-shadow: 0 0 5px 1px #5f5f5f;
      box-shadow: 0 0 5px 1px #5f5f5f;
      .close {
        position: absolute;
        right: 16px;
        svg path {
          color: black;
        }
      }
    }
  }
}
</style>